<template>
  <section class="w-full bg-blue-400/10 py-12">
    <div class="container-wrap">
      <div class="mb-6 tablet:mb-0 tablet:flex tablet:items-center">
        <div class="tablet:w-1/2 tablet:pr-2 desktop:flex-1 desktop:pr-6">
          <h2 class="mb-6 text-2xl font-bold text-blue-400 desktop:text-3xl">
            {{ contextData.sectionTitle }}
          </h2>
          <h3 class="mb-6 text-xl font-bold desktop:text-2xl">
            {{ contextData.title }}
          </h3>
          <p class="mb-6 w-full text-gray-600">
            {{ contextData.description }}
          </p>
          <div v-if="!isMobile" class="flex flex-wrap">
            <TheButton
              v-if="contextData.button?.text"
              :to="provideFormatUrl(contextData.button.link)"
              :title="contextData.button.text"
              class="mb-3 w-full tablet:mr-2.5 tablet:w-[180px] desktop:mr-6"
            >
              <span class="text-sm">
                {{ contextData.button.text }}
              </span>
            </TheButton>
          </div>
        </div>
        <div class="tablet:w-1/2 tablet:pl-2 desktop:w-[380px] desktop:pl-3">
          <LightboxVideo
            :video-data="video"
            class="aspect-video w-full rounded"
          />
        </div>
      </div>
      <div v-if="isMobile" class="flex flex-wrap">
        <TheButton
          v-if="contextData.button?.text"
          :to="provideFormatUrl(contextData.button.link)"
          :title="contextData.button.text"
          class="mb-3 w-full"
        >
          <span class="text-sm font-bold">
            {{ contextData.button.text }}
          </span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import EN_AMERICAS_JSON from '@/assets/data/home/en-americas/section-1-3.json';
  import EN_ASIA_PACIFIC_JSON from '@/assets/data/home/en-asia-pacific/section-1-3.json';
  import EN_EMEA_JSON from '@/assets/data/home/en-emea/section-1-3.json';
  import EN_INT_JSON from '@/assets/data/home/en-int/section-1-3.json';
  import EN_JP_JSON from '@/assets/data/home/en-jp/section-1-3.json';
  import EN_KR_JSON from '@/assets/data/home/en-kr/section-1-3.json';
  import EN_TW_JSON from '@/assets/data/home/en-tw/section-1-3.json';
  import JA_JP_JSON from '@/assets/data/home/ja-jp/section-1-3.json';
  import ZH_TW_JSON from '@/assets/data/home/zh-tw/section-1-3.json';
  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';

  interface IButton {
    text: string;
    link: string;
  }

  interface IHighlightData {
    sectionTitle: string;
    title: string;
    description: string;
    button: IButton;
  }

  const { locale } = useI18n();
  const { isMobile } = useScreen();
  const { blobDomain } = useWebsite();

  const { provideFormatUrl } = useFormatUrl();

  const contextData = computed((): IHighlightData => {
    switch (locale.value) {
      case EnumLocale.EN_INT:
        return EN_INT_JSON;
      case EnumLocale.EN_AMERICAS:
        return EN_AMERICAS_JSON;
      case EnumLocale.EN_JP:
        return EN_JP_JSON;
      case EnumLocale.EN_TW:
        return EN_TW_JSON;
      case EnumLocale.EN_KR:
        return EN_KR_JSON;
      case EnumLocale.EN_ASIA_PACIFIC:
        return EN_ASIA_PACIFIC_JSON;
      case EnumLocale.EN_EMEA:
        return EN_EMEA_JSON;
      case EnumLocale.ZH_TW:
        return ZH_TW_JSON;
      case EnumLocale.JA_JP:
        return JA_JP_JSON;
      default:
        return EN_INT_JSON;
    }
  });

  const video = computed(
    (): IVideoData => ({
      title: contextData.value.title,
      description: contextData.value.description,
      url: '4iptbkkmhf',
      imageUrl: `${blobDomain.value}/wise-paas-marketplace/pages/home/sections/section1/weda.webp`,
    })
  );
</script>
